export const deepLinkScheme = 'eskmo:';
export const codeLinkScheme = '/eskmo-app';
export const startDigitsSO = '9620';
export const startDigitsArray = ['5121', '5123'];
